/**
 * Central homepage icon registry.
 *
 * Icons live in:
 *   src/assets/images/homepageicons/{first|second|third|fifth|sixth}section/
 *   src/assets/images/brokeragespageicons/{second|third|fourth|fifth}section/
 *   src/assets/images/agentspageicons/{second|third|fourth|fifth}section/
 *   src/assets/images/vendorspageicons/{fourth|fifth|seventh}section/
 *   src/assets/images/installationpageicon/{third|fourth|fifth|sixth}section/
 * Import from here once, then use anywhere:
 *
 *   import { AppIcon } from '@/components/AppIcon';
 *
 *   <AppIcon name="checklist" size={18} alt="Checklist" />
 *   <AppIcon name="officeMan" size={40} />
 *   <AppIcon name="noAgentOversight" size={24} />
 *   <AppIcon name="officeAgentManagement" size={28} />
 *   <AppIcon name="goOnManagement" size={20} />
 *   <AppIcon name="saveTime" size={28} />
 */

// --- firstsection ---
import ChecklistIcon from '@/assets/images/homepageicons/firstsection/checklist.svg';
import MapsAndLocationIcon from '@/assets/images/homepageicons/firstsection/maps-and-location.svg';
import ShippingAndDeliveryIcon from '@/assets/images/homepageicons/firstsection/shipping-and-delivery.svg';
import WarehouseIcon from '@/assets/images/homepageicons/firstsection/warehouse.svg';

// --- secondsection ---
import CameraIcon from '@/assets/images/homepageicons/secondsection/camera.svg';
import ColorPaletteIcon from '@/assets/images/homepageicons/secondsection/color-palette.svg';
import FlashIcon from '@/assets/images/homepageicons/secondsection/flash.svg';
import FolderIcon from '@/assets/images/homepageicons/secondsection/folder.svg';
import InventoryIcon from '@/assets/images/homepageicons/secondsection/inventory.svg';
import MobilePhoneIcon from '@/assets/images/homepageicons/secondsection/mobile-phone.svg';
import NotificationIcon from '@/assets/images/homepageicons/secondsection/notification.svg';
import PicturesIcon from '@/assets/images/homepageicons/secondsection/pictures.svg';
import PlaceIcon from '@/assets/images/homepageicons/secondsection/place.svg';
import ProductManagementIcon from '@/assets/images/homepageicons/secondsection/product-management.svg';
import ReloadIcon from '@/assets/images/homepageicons/secondsection/reload.svg';
import ScheduleIcon from '@/assets/images/homepageicons/secondsection/schedule.svg';
import ShieldIcon from '@/assets/images/homepageicons/secondsection/shield.svg';
import SignIcon from '@/assets/images/homepageicons/secondsection/sign.svg';
import StockIcon from '@/assets/images/homepageicons/secondsection/stock.svg';
import VendorIcon from '@/assets/images/homepageicons/secondsection/vendor.svg';

// --- thirdsection ---
import AirtableIcon from '@/assets/images/homepageicons/thirdsection/airtable.svg';
import AsanaIcon from '@/assets/images/homepageicons/thirdsection/asana.svg';
import Auth0Icon from '@/assets/images/homepageicons/thirdsection/auth0.svg';
import CalendlyIcon from '@/assets/images/homepageicons/thirdsection/calendly.svg';
import DropboxIcon from '@/assets/images/homepageicons/thirdsection/dropbox.svg';
import GithubIcon from '@/assets/images/homepageicons/thirdsection/github.svg';
import GoogleAnalyticsIcon from '@/assets/images/homepageicons/thirdsection/google-analytics.svg';
import GoogleDriveIcon from '@/assets/images/homepageicons/thirdsection/google-drive.svg';
import HubspotIcon from '@/assets/images/homepageicons/thirdsection/hubspot.svg';
import JiraIcon from '@/assets/images/homepageicons/thirdsection/jira.svg';
import NotionIcon from '@/assets/images/homepageicons/thirdsection/notion.svg';
import OutlookIcon from '@/assets/images/homepageicons/thirdsection/outlook.svg';
import QuickbooksIcon from '@/assets/images/homepageicons/thirdsection/quickbooks.svg';
import SalesforceIcon from '@/assets/images/homepageicons/thirdsection/salesforce.svg';
import ShopifyIcon from '@/assets/images/homepageicons/thirdsection/shopify.svg';
import SlackIcon from '@/assets/images/homepageicons/thirdsection/slack.svg';
import StripeIcon from '@/assets/images/homepageicons/thirdsection/stripe.svg';
import TableauIcon from '@/assets/images/homepageicons/thirdsection/tableau.svg';
import TwilioIcon from '@/assets/images/homepageicons/thirdsection/twilio.svg';
import VimeoIcon from '@/assets/images/homepageicons/thirdsection/vimeo.svg';
import VscodeIcon from '@/assets/images/homepageicons/thirdsection/vscode.svg';
import ZapierIcon from '@/assets/images/homepageicons/thirdsection/zapier.svg';
import ZendeskIcon from '@/assets/images/homepageicons/thirdsection/zendesk.svg';

// --- fifthsection (Use Cases) ---
import AiIcon from '@/assets/images/homepageicons/fifthsection/ai.svg';
import CloudFolderIcon from '@/assets/images/homepageicons/fifthsection/cloud-folder.svg';
import CorporationIcon from '@/assets/images/homepageicons/fifthsection/corporation.svg';
import OfficeManIcon from '@/assets/images/homepageicons/fifthsection/office-man.svg';
import FifthVendorIcon from '@/assets/images/homepageicons/fifthsection/vendor.svg';
import FifthWarehouseIcon from '@/assets/images/homepageicons/fifthsection/warehouse.svg';

// --- sixthsection ---
import ArtificialIntelligenceIcon from '@/assets/images/homepageicons/sixthsection/artificial-intelligence.svg';
import ConnectionsIcon from '@/assets/images/homepageicons/sixthsection/connections.svg';
import SixthFolderIcon from '@/assets/images/homepageicons/sixthsection/folder.svg';
import NoConnectionIcon from '@/assets/images/homepageicons/sixthsection/no-connection.svg';
import SaleIcon from '@/assets/images/homepageicons/sixthsection/sale.svg';
import WorkIcon from '@/assets/images/homepageicons/sixthsection/work.svg';

// --- homepageicons / sharedicons (WorkDrive illustration) ---
import HomeWorkdriveDocIcon from '@/assets/images/homepageicons/sharedicons/doc.svg';
import HomeWorkdriveExpiresIcon from '@/assets/images/homepageicons/sharedicons/expires.svg';
import HomeWorkdriveFolderIcon from '@/assets/images/homepageicons/sharedicons/folder.svg';
import HomeWorkdriveFolder01Icon from '@/assets/images/homepageicons/sharedicons/folder01.svg';
import HomeWorkdriveIconIcon from '@/assets/images/homepageicons/sharedicons/icon.svg';
import HomeWorkdriveFolderStructureIcon from '@/assets/images/homepageicons/sharedicons/folder-structure.svg';
import HomeWorkdriveJpgIcon from '@/assets/images/homepageicons/sharedicons/jpg-file.svg';
import HomeWorkdriveNoVisibilityIcon from '@/assets/images/homepageicons/sharedicons/no-visibility.svg';
import HomeWorkdrivePasswordProtectedIcon from '@/assets/images/homepageicons/sharedicons/password-protected.svg';
import HomeWorkdrivePdfIcon from '@/assets/images/homepageicons/sharedicons/pdf.svg';
import HomeWorkdriveSecureShareIcon from '@/assets/images/homepageicons/sharedicons/secure-share.svg';
import HomeWorkdriveSheetsIcon from '@/assets/images/homepageicons/sharedicons/sheets.svg';
import HomeWorkdriveTeamPermissionsIcon from '@/assets/images/homepageicons/sharedicons/team-permissions.svg';
import HomeWorkdriveTxtIcon from '@/assets/images/homepageicons/sharedicons/txt-file.svg';

// --- brokeragespageicons / secondsection (Pain Points) ---
import BrandInconsistencyIcon from '@/assets/images/brokeragespageicons/secondsection/brand-inconsistency.svg';
import CoordinationOverloadIcon from '@/assets/images/brokeragespageicons/secondsection/coordination-overload.svg';
import FileChaosIcon from '@/assets/images/brokeragespageicons/secondsection/file-chaos.svg';
import InvoiceChaosIcon from '@/assets/images/brokeragespageicons/secondsection/invoice-chaos.svg';
import LostInventoryIcon from '@/assets/images/brokeragespageicons/secondsection/lost-inventory.svg';
import NoAgentOversightIcon from '@/assets/images/brokeragespageicons/secondsection/no-agent-oversight.svg';
import NoVisibilityIcon from '@/assets/images/brokeragespageicons/secondsection/no-visibility.svg';
import UncontrolledOperationalSpendIcon from '@/assets/images/brokeragespageicons/secondsection/uncontrolled-operational-spend.svg';

// --- brokeragespageicons / thirdsection (Core Features) ---
import BrandConsistencyIcon from '@/assets/images/brokeragespageicons/thirdsection/brand-consistency.svg';
import CentralizedBillingIcon from '@/assets/images/brokeragespageicons/thirdsection/centralized-billing.svg';
import InventoryManagementIcon from '@/assets/images/brokeragespageicons/thirdsection/inventory-management.svg';
import OfficeAgentManagementIcon from '@/assets/images/brokeragespageicons/thirdsection/office-agent-management.svg';
import ReportingInsightIcon from '@/assets/images/brokeragespageicons/thirdsection/reporting-insight.svg';
import ThirdVendorIcon from '@/assets/images/brokeragespageicons/thirdsection/vendor.svg';
import WorkdriveBrokerageIcon from '@/assets/images/brokeragespageicons/thirdsection/workdrive-brokerage.svg';

// --- brokeragespageicons / fourthsection (Mobile App) ---
import AgentEmpowermentIcon from '@/assets/images/brokeragespageicons/fourthsection/agent-empowerment.svg';
import GoOnManagementIcon from '@/assets/images/brokeragespageicons/fourthsection/go-on-management.svg';
import InventoryFieldIcon from '@/assets/images/brokeragespageicons/fourthsection/inventory-field.svg';
import MainMobilePhoneIcon from '@/assets/images/brokeragespageicons/fourthsection/main-mobile-phone.svg';
import RealTimeUpdatesIcon from '@/assets/images/brokeragespageicons/fourthsection/real-time-updates.svg';
import VendorFileSharingIcon from '@/assets/images/brokeragespageicons/fourthsection/vendor-file-sharing.svg';

// --- brokeragespageicons / fifthsection (Outcomes & Benefits) ---
import ConsistentBrandIcon from '@/assets/images/brokeragespageicons/fifthsection/consistent-brand.svg';
import CutCostIcon from '@/assets/images/brokeragespageicons/fifthsection/cut-cost.svg';
import EmpowerAgentIcon from '@/assets/images/brokeragespageicons/fifthsection/empower-agent.svg';
import FasterLaunchesIcon from '@/assets/images/brokeragespageicons/fifthsection/faster-launches.svg';
import FinancialVisibilityIcon from '@/assets/images/brokeragespageicons/fifthsection/financial-visibility.svg';
import ReduceErrorsIcon from '@/assets/images/brokeragespageicons/fifthsection/reduce-errors.svg';
import SaveTimeIcon from '@/assets/images/brokeragespageicons/fifthsection/save-time.svg';
import SmartCollaborationIcon from '@/assets/images/brokeragespageicons/fifthsection/smart-collaboration.svg';
import VendorAccountabilityIcon from '@/assets/images/brokeragespageicons/fifthsection/vendor-accountability.svg';

// --- agentspageicons / secondsection (Agent Challenges) ---
import EndlessCallsEmailsIcon from '@/assets/images/agentspageicons/secondsection/endless-calls-emails.svg';
import InconsistentCostsIcon from '@/assets/images/agentspageicons/secondsection/inconsistent-costs.svg';
import ManualInventoryTrackingIcon from '@/assets/images/agentspageicons/secondsection/manual-inventory-tracking.svg';
import NoMobileVisibilityIcon from '@/assets/images/agentspageicons/secondsection/no-mobile-visibility.svg';
import NoSignVisibilityIcon from '@/assets/images/agentspageicons/secondsection/no-sign-visibility.svg';
import VendorConfusionIcon from '@/assets/images/agentspageicons/secondsection/vendor-confusion.svg';

// --- agentspageicons / thirdsection (Core Features) ---
import FileSharingWorkdriveIcon from '@/assets/images/agentspageicons/thirdsection/file-sharing-workdrive.svg';
import FlexibleHandoverIcon from '@/assets/images/agentspageicons/thirdsection/flexible-handover.svg';
import InventorySignConditionIcon from '@/assets/images/agentspageicons/thirdsection/inventory-sign-condition.svg';
import MapBasedOrderingIcon from '@/assets/images/agentspageicons/thirdsection/map-based-ordering.svg';
import MobileAppForAgentsIcon from '@/assets/images/agentspageicons/thirdsection/mobile-app-for-agents.svg';
import PaymentDiscountOrderingIcon from '@/assets/images/agentspageicons/thirdsection/payment-discount-ordering.svg';
import RealTimeJobTrackingIcon from '@/assets/images/agentspageicons/thirdsection/real-time-job-tracking.svg';
import SmartOrderingIcon from '@/assets/images/agentspageicons/thirdsection/smart-ordering.svg';

// --- agentspageicons / fourthsection (Outcomes & Benefits) ---
import AccurateTrackingIcon from '@/assets/images/agentspageicons/fourthsection/accurate-tracking.svg';
import ConsistencyBrandingIcon from '@/assets/images/agentspageicons/fourthsection/consistency-branding.svg';
import FasterInstallationIcon from '@/assets/images/agentspageicons/fourthsection/faster-installation.svg';
import FinancialClarityIcon from '@/assets/images/agentspageicons/fourthsection/financial-clarity.svg';
import FullSignVisibilityIcon from '@/assets/images/agentspageicons/fourthsection/full-sign-visibility.svg';
import LessAdminWorkIcon from '@/assets/images/agentspageicons/fourthsection/less-admin-work.svg';
import OnTheGoManagementIcon from '@/assets/images/agentspageicons/fourthsection/on-the-go-management.svg';

// --- agentspageicons / fifthsection (Coming Soon) ---
import ComingSoonIcon from '@/assets/images/agentspageicons/fifthsection/coming-soon.svg';

// --- vendorspageicons / fourthsection (Core Features) ---
import AccountingPaymentIcon from '@/assets/images/vendorspageicons/fourthsection/accounting-payment.svg';
import AssetsInventoryManagementIcon from '@/assets/images/vendorspageicons/fourthsection/assets-inventory-management.svg';
import CmsToolsIcon from '@/assets/images/vendorspageicons/fourthsection/cms-tools.svg';
import CommerceConnectedVendorPortalIcon from '@/assets/images/vendorspageicons/fourthsection/commerce-connected-vendor-portal.svg';
import MobileAppForVendorsIcon from '@/assets/images/vendorspageicons/fourthsection/mobile-app-for-vendors.svg';
import VendorReportingInsightsIcon from '@/assets/images/vendorspageicons/fourthsection/reporting-insights.svg';
import ServiceOrderIntegrationIcon from '@/assets/images/vendorspageicons/fourthsection/service-order-integration.svg';

// --- vendorspageicons / fifthsection (Outcomes & Benefits) ---
import AutomatedOperationsIcon from '@/assets/images/vendorspageicons/fifthsection/automated-operations.svg';
import GainVisibilityInstantlyIcon from '@/assets/images/vendorspageicons/fifthsection/gain-visibility-instantly.svg';
import GetPaidFasterIcon from '@/assets/images/vendorspageicons/fifthsection/get-paid-faster.svg';
import IncreaseRevenueIcon from '@/assets/images/vendorspageicons/fifthsection/increase-revenue.svg';
import ReachNewBrokeragesIcon from '@/assets/images/vendorspageicons/fifthsection/reach-new-brokerages.svg';
import ScaleSmarterIcon from '@/assets/images/vendorspageicons/fifthsection/scale-smarter.svg';

// --- vendorspageicons / seventhsection (FAQs) ---
import FaqQuestionIcon from '@/assets/images/vendorspageicons/seventhsection/faq-question.svg';

// --- installationpageicon / thirdsection (Key Features) ---
import AccurateMapPinLocationIcon from '@/assets/images/installationpageicon/thirdsection/accurate-map-pin-location.svg';
import CreateManageJobIcon from '@/assets/images/installationpageicon/thirdsection/create-manage-job.svg';
import FlexibleHandoverDeliveryIcon from '@/assets/images/installationpageicon/thirdsection/flexible-handover-delivery.svg';
import FlexibleInventoryVendorOptionsIcon from '@/assets/images/installationpageicon/thirdsection/flexible-inventory-vendor-options.svg';
import MobileAppAccessIcon from '@/assets/images/installationpageicon/thirdsection/mobile-app-access.svg';
import PaymentBillingSimpleIcon from '@/assets/images/installationpageicon/thirdsection/payment-billing-simple.svg';
import QuickActionsFasterWorkflowIcon from '@/assets/images/installationpageicon/thirdsection/quick-actions-faster-workflow.svg';
import InstallRealTimeNotificationIcon from '@/assets/images/installationpageicon/thirdsection/real-time-notification.svg';
import SmartSchedulingPriorityIcon from '@/assets/images/installationpageicon/thirdsection/smart-scheduling-priority.svg';
import VerifiedProofInstallationIcon from '@/assets/images/installationpageicon/thirdsection/verified-proof-installation.svg';

// --- installationpageicon / fourthsection (Workflow) ---
import WorkflowCompletedIcon from '@/assets/images/installationpageicon/fourthsection/completed.svg';
import WorkflowInProgressIcon from '@/assets/images/installationpageicon/fourthsection/in-progress.svg';
import WorkflowPaidIcon from '@/assets/images/installationpageicon/fourthsection/paid.svg';
import WorkflowScheduledIcon from '@/assets/images/installationpageicon/fourthsection/scheduled.svg';

// --- installationpageicon / fifthsection (What You Can Do) ---
import CreateOrdersAnywhereIcon from '@/assets/images/installationpageicon/fifthsection/create-orders-anywhere.svg';
import EditOrRescheduleIcon from '@/assets/images/installationpageicon/fifthsection/edit-or-reschedule.svg';
import ManageInventoryOnSiteIcon from '@/assets/images/installationpageicon/fifthsection/manage-inventory-on-site.svg';
import StayNotifiedIcon from '@/assets/images/installationpageicon/fifthsection/stay-notified.svg';
import TrackProgressRealtimeIcon from '@/assets/images/installationpageicon/fifthsection/track-progress-realtime.svg';

// --- installationpageicon / sixthsection (Benefits) ---
import ControlInventoryIcon from '@/assets/images/installationpageicon/sixthsection/control-inventory.svg';
import EnsureQualityIcon from '@/assets/images/installationpageicon/sixthsection/ensure-quality.svg';
import InstallReduceCostIcon from '@/assets/images/installationpageicon/sixthsection/reduce-cost.svg';
import InstallSaveTimeIcon from '@/assets/images/installationpageicon/sixthsection/save-time.svg';
import ScaleOperationsIcon from '@/assets/images/installationpageicon/sixthsection/scale-operations.svg';

// --- removalpageicon / thirdsection (Key Features) ---
import RemovalAgentLevelTransparencyIcon from '@/assets/images/removalpageicon/thirdsection/agent-level-transparency.svg';
import AutomaticInventoryRestockingIcon from '@/assets/images/removalpageicon/thirdsection/automatic-inventory-restocking.svg';
import KnowConditionRestockedSignsIcon from '@/assets/images/removalpageicon/thirdsection/know-condition-restocked-signs.svg';
import PhotoProofOfRemovalIcon from '@/assets/images/removalpageicon/thirdsection/photo-proof-of-removal.svg';
import RemovalMobileAppAccessIcon from '@/assets/images/removalpageicon/thirdsection/removal-mobile-app-access.svg';
import ScheduleRemovalsAdvanceIcon from '@/assets/images/removalpageicon/thirdsection/schedule-removals-advance.svg';
import StayNotifiedStayInControlIcon from '@/assets/images/removalpageicon/thirdsection/stay-notified-stay-in-control.svg';
import RemovalBeyondSignsIcon from '@/assets/images/removalpageicon/thirdsection/beyond-signs.svg';
import RemovalDetailedRemovalNotesIcon from '@/assets/images/removalpageicon/thirdsection/detailed-removal-notes.svg';
import RemovalFlexiblePaymentsBillingIcon from '@/assets/images/removalpageicon/thirdsection/flexible-payments-billing.svg';

// --- removalpageicon / fourthsection (Workflow) ---
import RemovalWorkflowCompletedIcon from '@/assets/images/removalpageicon/fourthsection/completed.svg';
import RemovalWorkflowDraftIcon from '@/assets/images/removalpageicon/fourthsection/draft.svg';
import RemovalWorkflowInProgressIcon from '@/assets/images/removalpageicon/fourthsection/in-progress.svg';
import RemovalWorkflowRestockedIcon from '@/assets/images/removalpageicon/fourthsection/restocked.svg';
import RemovalWorkflowScheduledIcon from '@/assets/images/removalpageicon/fourthsection/scheduled.svg';

// --- removalpageicon / fifthsection (Mobile App) ---
import ApproveOrScheduleJobQuickActionIcon from '@/assets/images/removalpageicon/fifthsection/approve-or-schedule-job-quick-action.svg';
import CreateRemovalOrderFromAnywhereIcon from '@/assets/images/removalpageicon/fifthsection/create-removal-order-from-anywhere.svg';
import GetNotifiedAssetsRestockedIcon from '@/assets/images/removalpageicon/fifthsection/get-notified-assets-restocked.svg';
import MonitorConditionAssessmentIcon from '@/assets/images/removalpageicon/fifthsection/monitor-condition-assessment.svg';
import ReviewPhotoProofInstantlyIcon from '@/assets/images/removalpageicon/fifthsection/review-photo-proof-instantly.svg';
import TrackRemovalLiveProgressIndicatorIcon from '@/assets/images/removalpageicon/fifthsection/track-removal-live-progress-indicator.svg';

// --- removalpageicon / sixthsection (Benefits) ---
import RemovalImproveEfficiencyIcon from '@/assets/images/removalpageicon/sixthsection/improve-efficiency.svg';
import RemovalManageInventoryIcon from '@/assets/images/removalpageicon/sixthsection/manage-inventory.svg';
import RemovalProtectAssetsIcon from '@/assets/images/removalpageicon/sixthsection/protect-assets.svg';
import RemovalSaveMoneyIcon from '@/assets/images/removalpageicon/sixthsection/save-money.svg';
import RemovalVerifyCompletionIcon from '@/assets/images/removalpageicon/sixthsection/verify-completion.svg';

// --- workdrivepageicon / secondsection (Headline Benefits) ---
import WorkdriveComplianceMadeSimpleIcon from '@/assets/images/workdrivepageicon/secondsection/compliance-made-simple.svg';
import WorkdriveEverythingInOnePlaceIcon from '@/assets/images/workdrivepageicon/secondsection/everything-in-one-place.svg';
import WorkdriveFasterDealsIcon from '@/assets/images/workdrivepageicon/secondsection/faster-deals.svg';
import WorkdriveMobileReadyIcon from '@/assets/images/workdrivepageicon/secondsection/mobile-ready.svg';

// --- workdrivepageicon / fourthsection (Why Agents Adopt It Quickly) ---
import WorkdriveNoLearningCurveIcon from '@/assets/images/workdrivepageicon/fourthsection/no-learning-curve.svg';
import WorkdriveOneLinkPerClientIcon from '@/assets/images/workdrivepageicon/fourthsection/one-link-per-client.svg';
import WorkdriveStarFavouriteIcon from '@/assets/images/workdrivepageicon/fourthsection/star-favourite.svg';
import WorkdriveWorkAnywhereIcon from '@/assets/images/workdrivepageicon/fourthsection/work-anywhere.svg';

// --- workdrivepageicon / sixthsection (Mobile App) ---
import WorkdriveAttachToListingOnSiteIcon from '@/assets/images/workdrivepageicon/sixthsection/attach-to-listing-on-site.svg';
import WorkdriveCaptureUploadInstantlyIcon from '@/assets/images/workdrivepageicon/sixthsection/capture-upload-instantly.svg';
import WorkdriveOfflineAccessIcon from '@/assets/images/workdrivepageicon/sixthsection/offline-access.svg';
import WorkdriveQuickFileManagementIcon from '@/assets/images/workdrivepageicon/sixthsection/quick-file-management.svg';
import WorkdriveRealTimeSyncIcon from '@/assets/images/workdrivepageicon/sixthsection/real-time-sync.svg';
import WorkdriveSecureClientSharingIcon from '@/assets/images/workdrivepageicon/sixthsection/secure-client-sharing.svg';

// --- workdrivepageicon / seventhsection (Real Estate Workflows) ---
import WorkdriveBrokerageOperationIcon from '@/assets/images/workdrivepageicon/seventhsection/brokerage-operation.svg';
import WorkdriveInstallRemovalIcon from '@/assets/images/workdrivepageicon/seventhsection/install-removal.svg';
import WorkdriveMarketingIcon from '@/assets/images/workdrivepageicon/seventhsection/marketing.svg';
import WorkdriveTransactionIcon from '@/assets/images/workdrivepageicon/seventhsection/transaction.svg';

// --- workdrivepageicon / eightsection (What's Included) ---
import WorkdriveEssentialFileManagementIcon from '@/assets/images/workdrivepageicon/eightsection/essential-file-management.svg';
import WorkdriveFileOperationIcon from '@/assets/images/workdrivepageicon/eightsection/file-operation.svg';
import WorkdriveMobileAccessIcon from '@/assets/images/workdrivepageicon/eightsection/mobile-access.svg';
import WorkdriveSearchDiscoveryIcon from '@/assets/images/workdrivepageicon/eightsection/search-discovery.svg';
import WorkdriveSecureSharingIcon from '@/assets/images/workdrivepageicon/eightsection/secure-sharing.svg';
import WorkdriveTeamCollaborationIcon from '@/assets/images/workdrivepageicon/eightsection/team-collaboration.svg';

// --- workdrivepageicon / sharedicons (dashboard & shared UI) ---
import WorkdriveSharedClockIcon from '@/assets/images/workdrivepageicon/sharedicons/clock.svg';
import WorkdriveSharedDeleteIcon from '@/assets/images/workdrivepageicon/sharedicons/delete.svg';
import WorkdriveSharedFolderIcon from '@/assets/images/workdrivepageicon/sharedicons/folder.svg';
import WorkdriveSharedJpgIcon from '@/assets/images/workdrivepageicon/sharedicons/jpg-file.svg';
import WorkdriveSharedPdfIcon from '@/assets/images/workdrivepageicon/sharedicons/pdf.svg';
import WorkdriveSharedShareIcon from '@/assets/images/workdrivepageicon/sharedicons/share.svg';
import WorkdriveSharedSheetsIcon from '@/assets/images/workdrivepageicon/sharedicons/sheets.svg';
import WorkdriveSharedStarIcon from '@/assets/images/workdrivepageicon/sharedicons/star-favourite.svg';
import WorkdriveSharedAdminIcon from '@/assets/images/workdrivepageicon/sharedicons/admin.svg';
import WorkdriveSharedContractDisclosureIcon from '@/assets/images/workdrivepageicon/sharedicons/contract-disclosure.svg';
import WorkdriveSharedEditorIcon from '@/assets/images/workdrivepageicon/sharedicons/editor.svg';
import WorkdriveSharedInvoiceReceiptIcon from '@/assets/images/workdrivepageicon/sharedicons/invoice-receipt.svg';
import WorkdriveSharedListingCentricStructureIcon from '@/assets/images/workdrivepageicon/sharedicons/listing-centric-structure.svg';
import WorkdriveSharedOwnerIcon from '@/assets/images/workdrivepageicon/sharedicons/owner.svg';
import WorkdriveSharedPropertyPhotosIcon from '@/assets/images/workdrivepageicon/sharedicons/property-photos.svg';
import WorkdriveSharedSecurityFeaturesIcon from '@/assets/images/workdrivepageicon/sharedicons/security-features.svg';
import WorkdriveSharedSignageProofIcon from '@/assets/images/workdrivepageicon/sharedicons/signage-proof.svg';
import WorkdriveSharedTeamControlIcon from '@/assets/images/workdrivepageicon/sharedicons/team-control.svg';
import WorkdriveSharedViewerIcon from '@/assets/images/workdrivepageicon/sharedicons/viewer.svg';
import WorkdriveSharedPropertyPhotoZipIcon from '@/assets/images/workdrivepageicon/sharedicons/property-photo-zip.svg';
import WorkdriveSharedAiSummaryIcon from '@/assets/images/workdrivepageicon/sharedicons/ai-summary.svg';
import WorkdriveSharedAddressIcon from '@/assets/images/workdrivepageicon/sharedicons/address.svg';
import WorkdriveSharedDowntownOfficeIcon from '@/assets/images/workdrivepageicon/sharedicons/downtown-office.svg';
import WorkdriveSharedDropFileIcon from '@/assets/images/workdrivepageicon/sharedicons/drop-file.svg';
import WorkdriveSharedRecentActivityIcon from '@/assets/images/workdrivepageicon/sharedicons/recent-activity.svg';
import WorkdriveSharedAttachFileIcon from '@/assets/images/workdrivepageicon/sharedicons/attach-file.svg';
import WorkdriveSharedFastDeliveryIcon from '@/assets/images/workdrivepageicon/sharedicons/fast-delivery.svg';
import WorkdriveSharedSalesTeamIcon from '@/assets/images/workdrivepageicon/sharedicons/sales-team.svg';
import WorkdriveSharedPlaceholderIcon from '@/assets/images/workdrivepageicon/sharedicons/placeholder.svg';

// --- vendormarketplacepageicon / thirdsection (Empowers Brokerages & Agents) ---
import VendorMarketplaceEverythingInTheMobileAppIcon from '@/assets/images/vendormarketplacepageicon/thirdsection/everything-in-the-mobile-app.svg';
import VendorMarketplaceFlexiblePartnershipIcon from '@/assets/images/vendormarketplacepageicon/thirdsection/flexible-partnership.svg';
import VendorMarketplaceInvoiceMonthlySpendReportsIcon from '@/assets/images/vendormarketplacepageicon/thirdsection/invoice-monthly-spend-reports.svg';
import VendorMarketplaceOfficeControlledAgentFriendlyOrderingIcon from '@/assets/images/vendormarketplacepageicon/thirdsection/office-controlled-agent-friendly-ordering.svg';
import VendorMarketplaceOneStopVendorMarketplaceIcon from '@/assets/images/vendormarketplacepageicon/thirdsection/one-stop-vendor-marketplace.svg';
import VendorMarketplaceSeamlessOrdersPaymentsIcon from '@/assets/images/vendormarketplacepageicon/thirdsection/seamless-orders-payments.svg';
import VendorMarketplaceSharedPaymentFlexibilityIcon from '@/assets/images/vendormarketplacepageicon/thirdsection/shared-payment-flexibility.svg';
import VendorMarketplaceSmartInventorySyncIcon from '@/assets/images/vendormarketplacepageicon/thirdsection/smart-inventory-sync.svg';
import VendorMarketplaceTransparentVendorProfileIcon from '@/assets/images/vendormarketplacepageicon/thirdsection/transparent-vendor-profile.svg';
import VendorMarketplaceVendorAssistedIcon from '@/assets/images/vendormarketplacepageicon/thirdsection/vendor-assisted.svg';

// --- vendormarketplacepageicon / fourthsection (Vendor Marketplace Workflow) ---
import VendorMarketplaceBrowseCompareVendorIcon from '@/assets/images/vendormarketplacepageicon/fourthsection/browse-compare-vendor.svg';
import VendorMarketplaceManagePaymentIcon from '@/assets/images/vendormarketplacepageicon/fourthsection/manage-payment.svg';
import VendorMarketplacePlaceOrderIcon from '@/assets/images/vendormarketplacepageicon/fourthsection/place-order.svg';
import VendorMarketplaceTrackReportIcon from '@/assets/images/vendormarketplacepageicon/fourthsection/track-report.svg';

// --- vendormarketplacepageicon / fifthsection (Benefits) ---
import VendorMarketplaceControlCostIcon from '@/assets/images/vendormarketplacepageicon/fifthsection/control-cost.svg';
import VendorMarketplaceEmpowerOfficeAgentIcon from '@/assets/images/vendormarketplacepageicon/fifthsection/empower-office-agent.svg';
import VendorMarketplaceGainVisibilityIcon from '@/assets/images/vendormarketplacepageicon/fifthsection/gain-visibility.svg';
import VendorMarketplaceSellMoreManageLessIcon from '@/assets/images/vendormarketplacepageicon/fifthsection/sell-more-manage-less.svg';
import VendorMarketplaceSimplifyVendorManagementIcon from '@/assets/images/vendormarketplacepageicon/fifthsection/simplify-vendor-management.svg';

// --- reportspageicon / thirdsection (Core Features) ---
import ReportsFinancialInsightsTrackingIcon from '@/assets/images/reportspageicon/thirdsection/financial-insights-tracking.svg';
import ReportsMobileAccessKeyMetricsIcon from '@/assets/images/reportspageicon/thirdsection/mobile-access-key-metrics.svg';
import ReportsOperationsDashboardIcon from '@/assets/images/reportspageicon/thirdsection/operations-dashboard.svg';
import ReportsSignageInventoryReportIcon from '@/assets/images/reportspageicon/thirdsection/signage-inventory-report.svg';
import ReportsSmartForecastingAlertsIcon from '@/assets/images/reportspageicon/thirdsection/smart-forecasting-alerts.svg';
import ReportsVendorPerformanceIcon from '@/assets/images/reportspageicon/thirdsection/vendor-performance.svg';

// --- reportspageicon / fourthsection (Benefits) ---
import ReportsCostControlIcon from '@/assets/images/reportspageicon/fourthsection/cost-control.svg';
import ReportsRealTimeClarityIcon from '@/assets/images/reportspageicon/fourthsection/real-time-clarity.svg';
import ReportsSimplifiedDecisionMakingIcon from '@/assets/images/reportspageicon/fourthsection/simplified-decision-making.svg';
import ReportsTimeSavingsIcon from '@/assets/images/reportspageicon/fourthsection/time-savings.svg';
import ReportsTransparentPerformanceIcon from '@/assets/images/reportspageicon/fourthsection/transparent-performance.svg';

// --- reportspageicon / fifthsection (Integration) ---
import ReportsIntegrationErpSystemsIcon from '@/assets/images/reportspageicon/fifthsection/erp-systems.svg';
import ReportsIntegrationQuickbooksIcon from '@/assets/images/reportspageicon/fifthsection/quickbooks.svg';
import ReportsIntegrationSmartreadAiIcon from '@/assets/images/reportspageicon/fifthsection/smartread-ai.svg';
import ReportsIntegrationVendorPortalIcon from '@/assets/images/reportspageicon/fifthsection/vendor-portal.svg';
import ReportsIntegrationWorkdriveIcon from '@/assets/images/reportspageicon/fifthsection/workdrive.svg';
import ReportsIntegrationXeroIcon from '@/assets/images/reportspageicon/fifthsection/xero.svg';

// --- aboutuspageicon ---
import AboutAgentsIcon from '@/assets/images/aboutuspageicon/agents.svg';
import AboutBrokeragesIcon from '@/assets/images/aboutuspageicon/brokerages.svg';
import AboutOurMissionIcon from '@/assets/images/aboutuspageicon/our-mission.svg';
import AboutOurVisionIcon from '@/assets/images/aboutuspageicon/our-vision.svg';
import AboutVendorsIcon from '@/assets/images/aboutuspageicon/vendors.svg';
import AboutWhyWeExistIcon from '@/assets/images/aboutuspageicon/why-we-exist.svg';

// --- contactpageicon ---
import ContactPartnershipIcon from '@/assets/images/contactpageicon/partnership.svg';
import ContactSupportIcon from '@/assets/images/contactpageicon/support.svg';

// --- pricingpageicon / brokerage-agent-section ---
import PricingCustomDomainBrandingIcon from '@/assets/images/pricingpageicon/brokerage-agent-section/custom-domain-branding.svg';
import PricingEnterpriseIcon from '@/assets/images/pricingpageicon/brokerage-agent-section/enterprise.svg';
import PricingExtraAiDocumentCreditsIcon from '@/assets/images/pricingpageicon/brokerage-agent-section/extra-ai-document-credits.svg';
import PricingExtraWorkdriveStorageIcon from '@/assets/images/pricingpageicon/brokerage-agent-section/extra-workdrive-storage.svg';
import PricingMultiOfficeExpansionPackIcon from '@/assets/images/pricingpageicon/brokerage-agent-section/multi-office-expansion-pack.svg';
import PricingProfessionalIcon from '@/assets/images/pricingpageicon/brokerage-agent-section/professional.svg';
import PricingStarterIcon from '@/assets/images/pricingpageicon/brokerage-agent-section/starter.svg';

// --- pricingpageicon / vendors-section (All Vendor Plans Include) ---
import PricingAccessToRealesyMarketplaceIcon from '@/assets/images/pricingpageicon/vendors-section/access-to-realesy-marketplace.svg';
import PricingAutoTaxInvoiceGenerationIcon from '@/assets/images/pricingpageicon/vendors-section/auto-tax-invoice-generation.svg';
import PricingDirectChatOrderTrackingIcon from '@/assets/images/pricingpageicon/vendors-section/direct-chat-order-tracking.svg';
import PricingRealTimeJobUpdatesIcon from '@/assets/images/pricingpageicon/vendors-section/real-time-job-updates.svg';
import PricingRoleBasedTeamAccessIcon from '@/assets/images/pricingpageicon/vendors-section/role-based-team-access.svg';
import PricingSecurePaymentsStripeIcon from '@/assets/images/pricingpageicon/vendors-section/secure-payments-stripe.svg';

/** Named map — use with <AppIcon name="..." size={18} /> */
export const HomeIcons = {
  // firstsection
  checklist: ChecklistIcon,
  mapsAndLocation: MapsAndLocationIcon,
  shippingAndDelivery: ShippingAndDeliveryIcon,
  warehouse: WarehouseIcon,

  // secondsection
  camera: CameraIcon,
  colorPalette: ColorPaletteIcon,
  flash: FlashIcon,
  folder: FolderIcon,
  inventory: InventoryIcon,
  mobilePhone: MobilePhoneIcon,
  notification: NotificationIcon,
  pictures: PicturesIcon,
  place: PlaceIcon,
  productManagement: ProductManagementIcon,
  reload: ReloadIcon,
  schedule: ScheduleIcon,
  shield: ShieldIcon,
  sign: SignIcon,
  stock: StockIcon,
  vendor: VendorIcon,

  // thirdsection
  airtable: AirtableIcon,
  asana: AsanaIcon,
  auth0: Auth0Icon,
  calendly: CalendlyIcon,
  dropbox: DropboxIcon,
  github: GithubIcon,
  googleAnalytics: GoogleAnalyticsIcon,
  googleDrive: GoogleDriveIcon,
  hubspot: HubspotIcon,
  jira: JiraIcon,
  notion: NotionIcon,
  outlook: OutlookIcon,
  quickbooks: QuickbooksIcon,
  salesforce: SalesforceIcon,
  shopify: ShopifyIcon,
  slack: SlackIcon,
  stripe: StripeIcon,
  tableau: TableauIcon,
  twilio: TwilioIcon,
  vimeo: VimeoIcon,
  vscode: VscodeIcon,
  zapier: ZapierIcon,
  zendesk: ZendeskIcon,

  // fifthsection
  ai: AiIcon,
  cloudFolder: CloudFolderIcon,
  corporation: CorporationIcon,
  officeMan: OfficeManIcon,
  fifthVendor: FifthVendorIcon,
  fifthWarehouse: FifthWarehouseIcon,

  // sixthsection
  artificialIntelligence: ArtificialIntelligenceIcon,
  connections: ConnectionsIcon,
  sixthFolder: SixthFolderIcon,
  noConnection: NoConnectionIcon,
  sale: SaleIcon,
  work: WorkIcon,

  // homepageicons / sharedicons (WorkDrive illustration)
  homeWorkdriveFolder: HomeWorkdriveFolderIcon,
  homeWorkdriveFolder01: HomeWorkdriveFolder01Icon,
  homeWorkdriveIcon: HomeWorkdriveIconIcon,
  homeWorkdriveFolderStructure: HomeWorkdriveFolderStructureIcon,
  homeWorkdrivePdf: HomeWorkdrivePdfIcon,
  homeWorkdriveJpg: HomeWorkdriveJpgIcon,
  homeWorkdriveSheets: HomeWorkdriveSheetsIcon,
  homeWorkdriveDoc: HomeWorkdriveDocIcon,
  homeWorkdriveTxt: HomeWorkdriveTxtIcon,
  homeWorkdriveSecureShare: HomeWorkdriveSecureShareIcon,
  homeWorkdrivePasswordProtected: HomeWorkdrivePasswordProtectedIcon,
  homeWorkdriveExpires: HomeWorkdriveExpiresIcon,
  homeWorkdriveTeamPermissions: HomeWorkdriveTeamPermissionsIcon,
  homeWorkdriveNoVisibility: HomeWorkdriveNoVisibilityIcon,

  // brokeragespageicons / secondsection
  brandInconsistency: BrandInconsistencyIcon,
  coordinationOverload: CoordinationOverloadIcon,
  fileChaos: FileChaosIcon,
  invoiceChaos: InvoiceChaosIcon,
  lostInventory: LostInventoryIcon,
  noAgentOversight: NoAgentOversightIcon,
  noVisibility: NoVisibilityIcon,
  uncontrolledOperationalSpend: UncontrolledOperationalSpendIcon,

  // brokeragespageicons / thirdsection
  brandConsistency: BrandConsistencyIcon,
  centralizedBilling: CentralizedBillingIcon,
  inventoryManagement: InventoryManagementIcon,
  officeAgentManagement: OfficeAgentManagementIcon,
  reportingInsight: ReportingInsightIcon,
  thirdVendor: ThirdVendorIcon,
  workdriveBrokerage: WorkdriveBrokerageIcon,

  // brokeragespageicons / fourthsection
  agentEmpowerment: AgentEmpowermentIcon,
  goOnManagement: GoOnManagementIcon,
  inventoryField: InventoryFieldIcon,
  mainMobilePhone: MainMobilePhoneIcon,
  realTimeUpdates: RealTimeUpdatesIcon,
  vendorFileSharing: VendorFileSharingIcon,

  // brokeragespageicons / fifthsection
  consistentBrand: ConsistentBrandIcon,
  cutCost: CutCostIcon,
  empowerAgent: EmpowerAgentIcon,
  fasterLaunches: FasterLaunchesIcon,
  financialVisibility: FinancialVisibilityIcon,
  reduceErrors: ReduceErrorsIcon,
  saveTime: SaveTimeIcon,
  smartCollaboration: SmartCollaborationIcon,
  vendorAccountability: VendorAccountabilityIcon,

  // agentspageicons / secondsection
  endlessCallsEmails: EndlessCallsEmailsIcon,
  inconsistentCosts: InconsistentCostsIcon,
  manualInventoryTracking: ManualInventoryTrackingIcon,
  noMobileVisibility: NoMobileVisibilityIcon,
  noSignVisibility: NoSignVisibilityIcon,
  vendorConfusion: VendorConfusionIcon,

  // agentspageicons / thirdsection
  fileSharingWorkdrive: FileSharingWorkdriveIcon,
  flexibleHandover: FlexibleHandoverIcon,
  inventorySignCondition: InventorySignConditionIcon,
  mapBasedOrdering: MapBasedOrderingIcon,
  mobileAppForAgents: MobileAppForAgentsIcon,
  paymentDiscountOrdering: PaymentDiscountOrderingIcon,
  realTimeJobTracking: RealTimeJobTrackingIcon,
  smartOrdering: SmartOrderingIcon,

  // agentspageicons / fourthsection
  accurateTracking: AccurateTrackingIcon,
  consistencyBranding: ConsistencyBrandingIcon,
  fasterInstallation: FasterInstallationIcon,
  financialClarity: FinancialClarityIcon,
  fullSignVisibility: FullSignVisibilityIcon,
  lessAdminWork: LessAdminWorkIcon,
  onTheGoManagement: OnTheGoManagementIcon,

  // agentspageicons / fifthsection
  comingSoon: ComingSoonIcon,

  // vendorspageicons / fourthsection
  accountingPayment: AccountingPaymentIcon,
  assetsInventoryManagement: AssetsInventoryManagementIcon,
  cmsTools: CmsToolsIcon,
  commerceConnectedVendorPortal: CommerceConnectedVendorPortalIcon,
  mobileAppForVendors: MobileAppForVendorsIcon,
  vendorReportingInsights: VendorReportingInsightsIcon,
  serviceOrderIntegration: ServiceOrderIntegrationIcon,

  // vendorspageicons / fifthsection
  automatedOperations: AutomatedOperationsIcon,
  gainVisibilityInstantly: GainVisibilityInstantlyIcon,
  getPaidFaster: GetPaidFasterIcon,
  increaseRevenue: IncreaseRevenueIcon,
  reachNewBrokerages: ReachNewBrokeragesIcon,
  scaleSmarter: ScaleSmarterIcon,

  // vendorspageicons / seventhsection
  faqQuestion: FaqQuestionIcon,

  // installationpageicon / thirdsection
  accurateMapPinLocation: AccurateMapPinLocationIcon,
  createManageJob: CreateManageJobIcon,
  flexibleHandoverDelivery: FlexibleHandoverDeliveryIcon,
  flexibleInventoryVendorOptions: FlexibleInventoryVendorOptionsIcon,
  mobileAppAccess: MobileAppAccessIcon,
  paymentBillingSimple: PaymentBillingSimpleIcon,
  quickActionsFasterWorkflow: QuickActionsFasterWorkflowIcon,
  installRealTimeNotification: InstallRealTimeNotificationIcon,
  smartSchedulingPriority: SmartSchedulingPriorityIcon,
  verifiedProofInstallation: VerifiedProofInstallationIcon,

  // installationpageicon / fourthsection
  workflowCompleted: WorkflowCompletedIcon,
  workflowInProgress: WorkflowInProgressIcon,
  workflowPaid: WorkflowPaidIcon,
  workflowScheduled: WorkflowScheduledIcon,

  // installationpageicon / fifthsection
  createOrdersAnywhere: CreateOrdersAnywhereIcon,
  editOrReschedule: EditOrRescheduleIcon,
  manageInventoryOnSite: ManageInventoryOnSiteIcon,
  stayNotified: StayNotifiedIcon,
  trackProgressRealtime: TrackProgressRealtimeIcon,

  // installationpageicon / sixthsection
  controlInventory: ControlInventoryIcon,
  ensureQuality: EnsureQualityIcon,
  installReduceCost: InstallReduceCostIcon,
  installSaveTime: InstallSaveTimeIcon,
  scaleOperations: ScaleOperationsIcon,

  // removalpageicon / thirdsection
  scheduleRemovalsAdvance: ScheduleRemovalsAdvanceIcon,
  knowConditionRestockedSigns: KnowConditionRestockedSignsIcon,
  photoProofOfRemoval: PhotoProofOfRemovalIcon,
  automaticInventoryRestocking: AutomaticInventoryRestockingIcon,
  agentLevelTransparency: RemovalAgentLevelTransparencyIcon,
  stayNotifiedStayInControl: StayNotifiedStayInControlIcon,
  removalMobileAppAccess: RemovalMobileAppAccessIcon,
  detailedRemovalNotes: RemovalDetailedRemovalNotesIcon,
  flexiblePaymentsBilling: RemovalFlexiblePaymentsBillingIcon,
  beyondSigns: RemovalBeyondSignsIcon,

  // removalpageicon / fourthsection
  removalWorkflowDraft: RemovalWorkflowDraftIcon,
  removalWorkflowScheduled: RemovalWorkflowScheduledIcon,
  removalWorkflowInProgress: RemovalWorkflowInProgressIcon,
  removalWorkflowCompleted: RemovalWorkflowCompletedIcon,
  removalWorkflowRestocked: RemovalWorkflowRestockedIcon,

  // removalpageicon / fifthsection
  createRemovalOrderFromAnywhere: CreateRemovalOrderFromAnywhereIcon,
  trackRemovalLiveProgressIndicator: TrackRemovalLiveProgressIndicatorIcon,
  reviewPhotoProofInstantly: ReviewPhotoProofInstantlyIcon,
  approveOrScheduleJobQuickAction: ApproveOrScheduleJobQuickActionIcon,
  getNotifiedAssetsRestocked: GetNotifiedAssetsRestockedIcon,
  monitorConditionAssessment: MonitorConditionAssessmentIcon,

  // removalpageicon / sixthsection
  removalSaveMoney: RemovalSaveMoneyIcon,
  removalProtectAssets: RemovalProtectAssetsIcon,
  removalVerifyCompletion: RemovalVerifyCompletionIcon,
  removalImproveEfficiency: RemovalImproveEfficiencyIcon,
  removalManageInventory: RemovalManageInventoryIcon,

  // workdrivepageicon / secondsection
  workdriveEverythingInOnePlace: WorkdriveEverythingInOnePlaceIcon,
  workdriveFasterDeals: WorkdriveFasterDealsIcon,
  workdriveComplianceMadeSimple: WorkdriveComplianceMadeSimpleIcon,
  workdriveMobileReady: WorkdriveMobileReadyIcon,

  // workdrivepageicon / fourthsection
  workdriveNoLearningCurve: WorkdriveNoLearningCurveIcon,
  workdriveOneLinkPerClient: WorkdriveOneLinkPerClientIcon,
  workdriveStarFavourite: WorkdriveStarFavouriteIcon,
  workdriveWorkAnywhere: WorkdriveWorkAnywhereIcon,

  // workdrivepageicon / sixthsection
  workdriveCaptureUploadInstantly: WorkdriveCaptureUploadInstantlyIcon,
  workdriveAttachToListingOnSite: WorkdriveAttachToListingOnSiteIcon,
  workdriveSecureClientSharing: WorkdriveSecureClientSharingIcon,
  workdriveOfflineAccess: WorkdriveOfflineAccessIcon,
  workdriveQuickFileManagement: WorkdriveQuickFileManagementIcon,
  workdriveRealTimeSync: WorkdriveRealTimeSyncIcon,

  // workdrivepageicon / seventhsection
  workdriveMarketing: WorkdriveMarketingIcon,
  workdriveTransaction: WorkdriveTransactionIcon,
  workdriveInstallRemoval: WorkdriveInstallRemovalIcon,
  workdriveBrokerageOperation: WorkdriveBrokerageOperationIcon,

  // workdrivepageicon / eightsection
  workdriveEssentialFileManagement: WorkdriveEssentialFileManagementIcon,
  workdriveTeamCollaboration: WorkdriveTeamCollaborationIcon,
  workdriveFileOperation: WorkdriveFileOperationIcon,
  workdriveSecureSharing: WorkdriveSecureSharingIcon,
  workdriveSearchDiscovery: WorkdriveSearchDiscoveryIcon,
  workdriveMobileAccess: WorkdriveMobileAccessIcon,

  // workdrivepageicon / sharedicons
  workdriveSharedFolder: WorkdriveSharedFolderIcon,
  workdriveSharedStar: WorkdriveSharedStarIcon,
  workdriveSharedShare: WorkdriveSharedShareIcon,
  workdriveSharedClock: WorkdriveSharedClockIcon,
  workdriveSharedDelete: WorkdriveSharedDeleteIcon,
  workdriveSharedPdf: WorkdriveSharedPdfIcon,
  workdriveSharedJpg: WorkdriveSharedJpgIcon,
  workdriveSharedSheets: WorkdriveSharedSheetsIcon,
  workdriveSharedListingCentricStructure: WorkdriveSharedListingCentricStructureIcon,
  workdriveSharedPropertyPhotos: WorkdriveSharedPropertyPhotosIcon,
  workdriveSharedContractDisclosure: WorkdriveSharedContractDisclosureIcon,
  workdriveSharedSignageProof: WorkdriveSharedSignageProofIcon,
  workdriveSharedInvoiceReceipt: WorkdriveSharedInvoiceReceiptIcon,
  workdriveSharedTeamControl: WorkdriveSharedTeamControlIcon,
  workdriveSharedOwner: WorkdriveSharedOwnerIcon,
  workdriveSharedAdmin: WorkdriveSharedAdminIcon,
  workdriveSharedEditor: WorkdriveSharedEditorIcon,
  workdriveSharedViewer: WorkdriveSharedViewerIcon,
  workdriveSharedSecurityFeatures: WorkdriveSharedSecurityFeaturesIcon,
  workdriveSharedPropertyPhotoZip: WorkdriveSharedPropertyPhotoZipIcon,
  workdriveSharedAiSummary: WorkdriveSharedAiSummaryIcon,
  workdriveSharedAddress: WorkdriveSharedAddressIcon,
  workdriveSharedDowntownOffice: WorkdriveSharedDowntownOfficeIcon,
  workdriveSharedDropFile: WorkdriveSharedDropFileIcon,
  workdriveSharedRecentActivity: WorkdriveSharedRecentActivityIcon,
  workdriveSharedAttachFile: WorkdriveSharedAttachFileIcon,
  workdriveSharedFastDelivery: WorkdriveSharedFastDeliveryIcon,
  workdriveSharedSalesTeam: WorkdriveSharedSalesTeamIcon,
  workdriveSharedPlaceholder: WorkdriveSharedPlaceholderIcon,

  // vendormarketplacepageicon / thirdsection
  vendorMarketplaceOneStopVendorMarketplace: VendorMarketplaceOneStopVendorMarketplaceIcon,
  vendorMarketplaceSmartInventorySync: VendorMarketplaceSmartInventorySyncIcon,
  vendorMarketplaceSeamlessOrdersPayments: VendorMarketplaceSeamlessOrdersPaymentsIcon,
  vendorMarketplaceTransparentVendorProfile: VendorMarketplaceTransparentVendorProfileIcon,
  vendorMarketplaceFlexiblePartnership: VendorMarketplaceFlexiblePartnershipIcon,
  vendorMarketplaceOfficeControlledAgentFriendlyOrdering:
    VendorMarketplaceOfficeControlledAgentFriendlyOrderingIcon,
  vendorMarketplaceSharedPaymentFlexibility: VendorMarketplaceSharedPaymentFlexibilityIcon,
  vendorMarketplaceVendorAssisted: VendorMarketplaceVendorAssistedIcon,
  vendorMarketplaceInvoiceMonthlySpendReports: VendorMarketplaceInvoiceMonthlySpendReportsIcon,
  vendorMarketplaceEverythingInTheMobileApp: VendorMarketplaceEverythingInTheMobileAppIcon,

  // vendormarketplacepageicon / fourthsection
  vendorMarketplaceBrowseCompareVendor: VendorMarketplaceBrowseCompareVendorIcon,
  vendorMarketplacePlaceOrder: VendorMarketplacePlaceOrderIcon,
  vendorMarketplaceManagePayment: VendorMarketplaceManagePaymentIcon,
  vendorMarketplaceTrackReport: VendorMarketplaceTrackReportIcon,

  // vendormarketplacepageicon / fifthsection
  vendorMarketplaceSimplifyVendorManagement: VendorMarketplaceSimplifyVendorManagementIcon,
  vendorMarketplaceControlCost: VendorMarketplaceControlCostIcon,
  vendorMarketplaceGainVisibility: VendorMarketplaceGainVisibilityIcon,
  vendorMarketplaceEmpowerOfficeAgent: VendorMarketplaceEmpowerOfficeAgentIcon,
  vendorMarketplaceSellMoreManageLess: VendorMarketplaceSellMoreManageLessIcon,

  // reportspageicon / thirdsection
  reportsOperationsDashboard: ReportsOperationsDashboardIcon,
  reportsFinancialInsightsTracking: ReportsFinancialInsightsTrackingIcon,
  reportsSignageInventoryReport: ReportsSignageInventoryReportIcon,
  reportsVendorPerformance: ReportsVendorPerformanceIcon,
  reportsSmartForecastingAlerts: ReportsSmartForecastingAlertsIcon,
  reportsMobileAccessKeyMetrics: ReportsMobileAccessKeyMetricsIcon,

  // reportspageicon / fourthsection
  reportsRealTimeClarity: ReportsRealTimeClarityIcon,
  reportsSimplifiedDecisionMaking: ReportsSimplifiedDecisionMakingIcon,
  reportsTransparentPerformance: ReportsTransparentPerformanceIcon,
  reportsCostControl: ReportsCostControlIcon,
  reportsTimeSavings: ReportsTimeSavingsIcon,

  // reportspageicon / fifthsection
  reportsIntegrationWorkdrive: ReportsIntegrationWorkdriveIcon,
  reportsIntegrationVendorPortal: ReportsIntegrationVendorPortalIcon,
  reportsIntegrationSmartreadAi: ReportsIntegrationSmartreadAiIcon,
  reportsIntegrationQuickbooks: ReportsIntegrationQuickbooksIcon,
  reportsIntegrationXero: ReportsIntegrationXeroIcon,
  reportsIntegrationErpSystems: ReportsIntegrationErpSystemsIcon,

  // aboutuspageicon
  aboutOurVision: AboutOurVisionIcon,
  aboutOurMission: AboutOurMissionIcon,
  aboutWhyWeExist: AboutWhyWeExistIcon,
  aboutBrokerages: AboutBrokeragesIcon,
  aboutAgents: AboutAgentsIcon,
  aboutVendors: AboutVendorsIcon,

  // contactpageicon
  contactSupport: ContactSupportIcon,
  contactPartnership: ContactPartnershipIcon,

  // pricingpageicon / brokerage-agent-section
  pricingStarter: PricingStarterIcon,
  pricingProfessional: PricingProfessionalIcon,
  pricingEnterprise: PricingEnterpriseIcon,
  pricingExtraWorkdriveStorage: PricingExtraWorkdriveStorageIcon,
  pricingExtraAiDocumentCredits: PricingExtraAiDocumentCreditsIcon,
  pricingCustomDomainBranding: PricingCustomDomainBrandingIcon,
  pricingMultiOfficeExpansionPack: PricingMultiOfficeExpansionPackIcon,

  // pricingpageicon / vendors-section
  pricingAccessToRealesyMarketplace: PricingAccessToRealesyMarketplaceIcon,
  pricingDirectChatOrderTracking: PricingDirectChatOrderTrackingIcon,
  pricingSecurePaymentsStripe: PricingSecurePaymentsStripeIcon,
  pricingAutoTaxInvoiceGeneration: PricingAutoTaxInvoiceGenerationIcon,
  pricingRealTimeJobUpdates: PricingRealTimeJobUpdatesIcon,
  pricingRoleBasedTeamAccess: PricingRoleBasedTeamAccessIcon,
} as const;

/** Alias so existing imports of `Icons` still work */
export const Icons = HomeIcons;

export type IconName = keyof typeof HomeIcons;

/** Direct named exports */
export {
  ChecklistIcon,
  MapsAndLocationIcon,
  ShippingAndDeliveryIcon,
  WarehouseIcon,
  CameraIcon,
  ColorPaletteIcon,
  FlashIcon,
  FolderIcon,
  InventoryIcon,
  MobilePhoneIcon,
  NotificationIcon,
  PicturesIcon,
  PlaceIcon,
  ProductManagementIcon,
  ReloadIcon,
  ScheduleIcon,
  ShieldIcon,
  SignIcon,
  StockIcon,
  VendorIcon,
  AirtableIcon,
  AsanaIcon,
  Auth0Icon,
  CalendlyIcon,
  DropboxIcon,
  GithubIcon,
  GoogleAnalyticsIcon,
  GoogleDriveIcon,
  HubspotIcon,
  JiraIcon,
  NotionIcon,
  OutlookIcon,
  QuickbooksIcon,
  SalesforceIcon,
  ShopifyIcon,
  SlackIcon,
  StripeIcon,
  TableauIcon,
  TwilioIcon,
  VimeoIcon,
  VscodeIcon,
  ZapierIcon,
  ZendeskIcon,
  AiIcon,
  CloudFolderIcon,
  CorporationIcon,
  OfficeManIcon,
  FifthVendorIcon,
  FifthWarehouseIcon,
  ArtificialIntelligenceIcon,
  ConnectionsIcon,
  SixthFolderIcon,
  NoConnectionIcon,
  SaleIcon,
  WorkIcon,
  BrandInconsistencyIcon,
  CoordinationOverloadIcon,
  FileChaosIcon,
  InvoiceChaosIcon,
  LostInventoryIcon,
  NoAgentOversightIcon,
  NoVisibilityIcon,
  UncontrolledOperationalSpendIcon,
  BrandConsistencyIcon,
  CentralizedBillingIcon,
  InventoryManagementIcon,
  OfficeAgentManagementIcon,
  ReportingInsightIcon,
  ThirdVendorIcon,
  WorkdriveBrokerageIcon,
  AgentEmpowermentIcon,
  GoOnManagementIcon,
  InventoryFieldIcon,
  MainMobilePhoneIcon,
  RealTimeUpdatesIcon,
  VendorFileSharingIcon,
  ConsistentBrandIcon,
  CutCostIcon,
  EmpowerAgentIcon,
  FasterLaunchesIcon,
  FinancialVisibilityIcon,
  ReduceErrorsIcon,
  SaveTimeIcon,
  SmartCollaborationIcon,
  VendorAccountabilityIcon,
  EndlessCallsEmailsIcon,
  InconsistentCostsIcon,
  ManualInventoryTrackingIcon,
  NoMobileVisibilityIcon,
  NoSignVisibilityIcon,
  VendorConfusionIcon,
  FileSharingWorkdriveIcon,
  FlexibleHandoverIcon,
  InventorySignConditionIcon,
  MapBasedOrderingIcon,
  MobileAppForAgentsIcon,
  PaymentDiscountOrderingIcon,
  RealTimeJobTrackingIcon,
  SmartOrderingIcon,
  AccurateTrackingIcon,
  ConsistencyBrandingIcon,
  FasterInstallationIcon,
  FinancialClarityIcon,
  FullSignVisibilityIcon,
  LessAdminWorkIcon,
  OnTheGoManagementIcon,
  ComingSoonIcon,
  AccountingPaymentIcon,
  AssetsInventoryManagementIcon,
  CmsToolsIcon,
  CommerceConnectedVendorPortalIcon,
  MobileAppForVendorsIcon,
  VendorReportingInsightsIcon,
  ServiceOrderIntegrationIcon,
  AutomatedOperationsIcon,
  GainVisibilityInstantlyIcon,
  GetPaidFasterIcon,
  IncreaseRevenueIcon,
  ReachNewBrokeragesIcon,
  ScaleSmarterIcon,
  FaqQuestionIcon,
  AccurateMapPinLocationIcon,
  CreateManageJobIcon,
  FlexibleHandoverDeliveryIcon,
  FlexibleInventoryVendorOptionsIcon,
  MobileAppAccessIcon,
  PaymentBillingSimpleIcon,
  QuickActionsFasterWorkflowIcon,
  InstallRealTimeNotificationIcon,
  SmartSchedulingPriorityIcon,
  VerifiedProofInstallationIcon,
  WorkflowCompletedIcon,
  WorkflowInProgressIcon,
  WorkflowPaidIcon,
  WorkflowScheduledIcon,
  CreateOrdersAnywhereIcon,
  EditOrRescheduleIcon,
  ManageInventoryOnSiteIcon,
  StayNotifiedIcon,
  TrackProgressRealtimeIcon,
  ControlInventoryIcon,
  EnsureQualityIcon,
  InstallReduceCostIcon,
  InstallSaveTimeIcon,
  ScaleOperationsIcon,
};
